import { Link, LinkProps } from 'react-router-dom';
import styled, { withTheme } from 'styled-components';

const StyledLink = styled(Link)`
    color: ${props => props.theme.colors.primary};
    text-decoration: underline;
`;

export default withTheme(StyledLink) as React.ComponentType<Omit<LinkProps, 'theme'>>;
